import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'price',
    standalone: true,
})
export class PricePipe implements PipeTransform {
    transform(price: number, locale: string): string {
        const amount = price / 100;

        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: 'DKK',
            currencyDisplay: locale === 'en-US' ? 'code' : 'symbol',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);
    }
}